function getWindowOptions (model, port_width, port_height) {
  let height = parseInt(port_height) * 10 // from cm to mm
  let options = ['no_windows']
  let types = getWindowTypes(model) // For 9000 both types are available but for 8000 only default is.
  for (let i = 0; i < types.length; i++) {
    let type = types[i]
    let rows = getAllowedNumberOfRows(type, height)
    if (rows === null || rows < 1) continue // invalid sizes
    for (let i = 1; i <= rows.length; i++) {
      options.push(getOptionValue(type, i))
    }
  }
  return options
}

function getWindowTypes (model) {
  if (typeof model === 'undefined') {
    model = 9000
  }

  const window_types = {
    8000: [
      's80w'
    ],
    9000: [
      '90w',
      '90m',
    ]
  }

  return window_types[model]
}

function getAllowedNumberOfRows (type, height) {
  switch (type) {
    case '90w':
      if (height >= 2105 && height < 2780) {
        return [1]
      } else if (height >= 2780) {
        return [1, 2]
      } else {
        return []
      }
    case 's80w':
      if (height >= 2000 && height < 2180) {
        return [1]
      } else if (height >= 2180) {
        return [1, 2]
      } else {
        return []
      }
    case '90m':
      if (height >= 2265 && height < 2940) {
        return [1]
      } else if (height >= 2940) {
        return [1, 2]
      } else {
        return []
      }
      break
  }
}

function getColumnCount (type, width, door) {
  switch (type) {
    case '90w':
    case 's80w':
      if (door && width >= 2000 && width < 3000) {
        return 1
      } else if (width >= 2000 && width < 3000) {
        return 2
      } else if (width >= 3000 && width < 4000) {
        return 3
      } else if (width >= 4000 && width < 5000) {
        return 4
      } else if (width >= 5000 && width < 6000) {
        return 5
      } else if (width === 6000) {
        return 6
      }
      break
    case '90m':
      if (door && width >= 2000 && width < 3606) {
        return 3
      } else if (width >= 2000 && width < 2429) {
        return 2
      } else if (width >= 2429 && width < 3606) {
        return 3
      } else if (width >= 3606 && width < 4783) {
        return 4
      } else if (width >= 4783 && width < 5960) {
        return 5
      } else if (width >= 5960 && width <= 6000) {
        return 6
      }
      break
  }

  return null
}

function getOptionValue (type, rows) {
  return type + '_' + rows + 'r'
}

function decodeOptionValue (value) {
  return value.replace('r', '').split('_')
}

export { getWindowOptions, getColumnCount, decodeOptionValue }